import {CompetitorFilterRequestType} from '../../../page/main/reviews-analysis/reviews-analysis-type';
import {fetchAndDeserialize, serializeToURLParameters} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';

import {competitorByAspectPointListSchema, CompetitorByAspectPointType} from './review-competitors-by-aspect-type';

export function fetchCompetitorsByAspect(
    options: CompetitorFilterRequestType,
    aspectId: number,
    mainFilterKey: string
): Promise<Array<CompetitorByAspectPointType>> {
    // The single aspect from the route wins over any aspect filter in the URL.
    const searchParameters = objectToUrlParameters({
        ...serializeToURLParameters<CompetitorFilterRequestType>({...options, aspectIds: [aspectId]}),
        filter_key: mainFilterKey,
    });

    const url = `/v2/reviews-analytics/stats/competitors-by-aspect/?${searchParameters}`;

    return fetchAndDeserialize<Array<CompetitorByAspectPointType>>(url, competitorByAspectPointListSchema);
}
